module.exports = __webpack_public_path__ + "static/media/card4_3.1ec8935a.png";